import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { GenFormBuilder } from "../../../providers/form";
import { StaffData } from "../../../providers/staff";
import { Utilities } from "./../../../providers/utilities";

@Component({
  selector: "app-speaker-agenda-form",
  templateUrl: "speaker-agenda-form.html",
})
export class SpeakerAgendaFormComponent implements OnInit {

  @Input() public speakers: any[];
  @Input() public currentSpeaker: any;
  @Input() public clientId: string;
  @Input() public eventId: string;
  @Output() public createOrUpdateSpeaker = new EventEmitter();

  public form: FormGroup;
  public staff$: Observable<any[]>;
  public submitAttempt = false;

  constructor(
    private formGenerate: GenFormBuilder,
    private formBuilder: FormBuilder,
    private utilities: Utilities,
    private staffData: StaffData,
  ) { }

  public ngOnInit() {
    this.staff$ = this.staffData.getStaffsByClientId(this.clientId, this.eventId);

    this.form = this.formBuilder.group({});

    this.formGenerate.genInputString("id", this.form, false);
    this.formGenerate.genInputString("staffId", this.form, true);
    this.formGenerate.genInputString("segment", this.form);
    this.formGenerate.genToggle("state", this.form, false, true);

    if (this.currentSpeaker) {
      this.form.patchValue(this.currentSpeaker);
    }
  }

  public select(event) {
    if (event.result) {
      if (Object.keys(event.result).length === 1) {
        this.form.get("staffId").setValue(Object.keys(event.result)[0]);
      }
    }
  }

  public onSubmit({ value, valid }) {
    this.submitAttempt = true;
    if (valid) {
      this.createOrUpdateSpeaker.emit(value);
    } else {
      this.utilities.consoleError("Form", this.form);
      this.utilities.setToast("Form speaker contain errors", 3000, "top");
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/event-staff-agenda/speaker-agenda-form/speaker-agenda-form.ts